export default __webpack_public_path__ + "static/share-91c1ccaf069612d179bb890086b6607a.png";